import clsx from 'clsx';
import { gql } from 'graphql-request';
import { For, Show, createEffect, createMemo, createSignal, on } from 'solid-js';
import tailwindConfig from '../../../tailwind.config';
import { useAppContext } from '../../app-context-provider/app-context-provider';
import { ErrorCatcher } from '../../tools/error-catcher';
import { NewsListItem } from './news-list-item';
import { Button } from '../../ui-components/button/button';
import { ButtonColorName } from '../../style/color-classes';
import { PostListingSchema } from '../schema/post-listing';

type NewsArchiveProps = {
    limit?: number;
    offset?: number;
};

const GET_NEWS_QUERY = gql`
    query GetNewsPosts($limit: Int, $offset: Int) {
        news: resources(type: "news", limit: $limit, offset: $offset, order: DESC) {
            content
        }
    }
`;
// Can't get eslint to shut up about the unused vars
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const NewsArchive = (_componentProps: NewsArchiveProps) => {
    const { createCachedResource, viewport, translate } = useAppContext();

    const [isMobile, setIsMobile] = createSignal(viewport.width <= tailwindConfig.theme.extend.screenValues.tabletValue);
    const [isTablet, setIsTablet] = createSignal(viewport.width >= tailwindConfig.theme.extend.screenValues.tabletValue);
    createEffect(() => {
        setIsMobile(viewport.width <= tailwindConfig.theme.extend.screenValues.tabletValue);
        setIsTablet(viewport.width >= tailwindConfig.theme.extend.screenValues.tabletValue);
    });
    const [offset, setOffset] = createSignal(0);

    const [limit] = createSignal(20);
    const [posts, setPosts] = createSignal<any>([]);
    const [displayLoadMoreButton, setDisplayLoadMoreButton] = createSignal(false);

    const queryVars = createMemo(() => {
        return {
            limit: limit() + 1,
            offset: offset(),
        };
    });

    const [postsContent] = createCachedResource(GET_NEWS_QUERY, queryVars, true);

    const handleLoadMoreClick = () => {
        setOffset(offset() + limit());
    };

    createEffect(on(postsContent, (content) => {
        if (!content) return;

        setDisplayLoadMoreButton(content.news.length > limit());
        setPosts(prev => {
            if (offset() === 0) {
                return content.news.slice(0, limit());
            }
            return [...prev, ...content.news.slice(0, limit())];
        });
    }));

    return (
        <ErrorCatcher componentName="NewsArchive">
            <div>
                <Show when={postsContent() && posts().length > 0} fallback={<div class="h-screen"></div>}>
                    <div class="tablet:grid-cols-1 desktop:grid-cols-1 gap-y-xl gap-x-l tablet:gap-y-xxl tablet:gap-x-xxl mb-xl mt-20 grid grid-cols-1">
                        <For each={posts()}>
                            {(news) => {
                                return <NewsListItem news={news.content} isMobile={isMobile()} isTablet={isTablet()} />;
                            }}
                        </For>
                    </div>
                    <Show when={displayLoadMoreButton()}>
                        <div class="text-center">
                            <Button
                                variant="solid"
                                color={ButtonColorName.Primary}
                                onClick={() => handleLoadMoreClick()}
                                label={translate('load-more')}
                                buttonSize="small" />
                        </div>
                    </Show>
                </Show>
                
                
            </div>
            <PostListingSchema
                content={postsContent()?.news}
                postSingleType="ListItem"
                postListingType="itemListElement"
            />
        </ErrorCatcher>
    );
};
